import { render, staticRenderFns } from "./DashboardFavoriteBar.vue?vue&type=template&id=6ea936b2&scoped=true"
import script from "./DashboardFavoriteBar.vue?vue&type=script&lang=js"
export * from "./DashboardFavoriteBar.vue?vue&type=script&lang=js"
import style0 from "./DashboardFavoriteBar.vue?vue&type=style&index=0&id=6ea936b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea936b2",
  null
  
)

export default component.exports